export default "__VITE_ASSET__9fa33985__"